<script>
/**
 * ****************************************************************************
 * @description     :   Input DatePicker Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { mapMutations } from 'vuex';
import flatPickr from 'vue-flatpickr-component';
import _ from 'lodash-uuid';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
// import moment from 'moment';

/**
 * Import template
 */
import template from './template.html';
import { isArray } from 'lodash';
import helpers from '@/utils/helpers';
import moment from 'moment/moment';
import { timeoutFocus } from '@/utils/constants';
import { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';
/**
 * Define content of input datepicker component
 */
var AnsDatePicker = {
    template: template,
    props: {
        id: String,
        label: String,
        name: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        buttonClass: String,
        icon: String,
        placeholder: String,
        value: String,
        modelValue: Array,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        isTimer: {
            type: Boolean,
            default: false
        },
        showIcon: {
            type: Boolean,
            default: true
        },
        isMonthYear: {
            type: Boolean,
            default: false
        },
        isYearOnly: {
            type: Boolean,
            default: false
        },
        isAllowMonthYear: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: true
        },
        isHorizontal: {
            type: Boolean,
            default: false
        },
        widthLabel: {
            type: String,
            default: 'width-110-px'
        },
        isAllowInput: { type: Boolean, default: true },
        isAutocomplete: {
            type: Boolean,
            default: false
        },
        onChangeEvent: Function,
        onFocusEvent: Function,
        onBlurEvent: Function,
        onClick: Function,
        errors: {
            type: Array
        }
    },
    components: {
        flatPickr
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: '',
            isInputting: false,
            keyRender: 0,
            listDate: [],
            viewValue: '',
            tempDate: '',
            modeDisabled: false,
            errors: ''
        };
    },
    watch: {
        modelValue: {
            handler: function (val) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const nextYear = new Date();
                nextYear.setFullYear(today.getFullYear() + 1);
                nextYear.setHours(0, 0, 0, 0);

                val = val.filter((date) => {
                    const d = new Date(date);
                    return d >= today && d <= nextYear;
                });
                if (val.length > 3 && val.length <= 40) {
                    this.viewValue = val.slice(0, 3).join(',') + `    他${val.length - 3}件`;
                    this.errors = [];
                } else if (val.length > 40) {
                    this.viewValue = val.slice(0, 3).join(',') + `    他${val.length - 3}件`;
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.E001,
                        content: 'ご依頼につきまして、最大40日分までご入力いただけます。',
                        okText: MSG_BUTTON.okText
                    });
                    this.errors = [
                        {
                            name: this.id,
                            message: ' '
                        }
                    ];
                } else {
                    this.viewValue = val.toString();
                }
                this.listDate = val;
            },
            deep: true
        }
    },
    computed: {
        vewValue: {
            get() {
                // return this.getValue(
                //     this.listDate.length ? this.listDate : this.modelValue
                // );
                return [];
            },
            set() {}
        },
        config_datetime() {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const nextYear = new Date();
            nextYear.setFullYear(today.getFullYear() + 1); // Cộng thêm 1 năm
            nextYear.setHours(0, 0, 0, 0);
            return {
                wrap: true,
                // eslint-disable-next-line prettier/prettier
                altFormat: this.isMonthYear ? 'Y/m' : this.isYearOnly ? 'Y' : 'Y/m/d',
                altInput: true,
                // eslint-disable-next-line prettier/prettier
                dateFormat: this.isMonthYear ? 'Y/m' : this.isYearOnly ? 'Y/m/d' : 'Y/m/d',
                allowInput: this.isAllowInput,
                clickOpens: false,
                monthSelectorType: 'static',
                locale: Japanese,
                onChange: this.updateInput,
                onOpen: this.onOpenModal,
                mode: 'multiple',
                minDate: today,
                maxDate: nextYear
            };
        },
        maxlength() {
            // eslint-disable-next-line prettier/prettier
            return this.isTimer ? 5 : this.isYearOnly ? 4 : this.isMonthYear ? 7 : 10;
        },
        validateError() {
            let message = '';
            if (this.errors) {
                this.errors.forEach((item) => {
                    if (item.name == this.id) {
                        message = item.message;
                    }
                });
            }
            return message;
        },
        checkRequireValue() {
            return this.listDate.filter((item) => item).length;
        }
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _.uuid();
        }
        this.vewValue = this.modelValue;
        this.modeDisabled = helpers.checkAuthorityMode(this.$route.name);
    },
    methods: {
        ...mapMutations('app', ['showModalMessage']),
        sortDate(dates) {
            return dates.sort(function (a, b) {
                let dateA = new Date(a);
                let dateB = new Date(b);
                return dateA - dateB;
            });
        },
        appendOkButton() {
            const button = document.getElementById('ok-calendar');
            if (button) {
                button.remove();
            }
            const el = document.getElementsByClassName('flatpickr-calendar')[0];
            const node = document.createElement('button');
            const text = document.createTextNode('OK');
            node.setAttribute('id', 'ok-calendar');
            node.classList.add('width-100-px');
            node.classList.add('btn');
            node.classList.add('btn-outline-primary');
            node.classList.add('mb-2');
            node.appendChild(text);
            el.appendChild(node);
            setTimeout(() => {
                node.addEventListener(
                    'click',
                    () => {
                        this.closeCalendar();
                    },
                    false
                );
            }, timeoutFocus);
        },
        closeCalendar() {
            const icon = document.getElementById('calendar-icon');
            icon.click();
            this.listDate = this.sortDate(this.tempDate.split(', '));
            this.viewValue = this.listDate.toString();
            this.$emit('update:modelValue', this.listDate);
        },
        onOpenModal(selectedDates, dateStr, instance) {
            instance.setDate(this.listDate, () => {}, 'Y/m/d');
            this.appendOkButton();
        },
        /**
         * convert date for input datepiker
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        convertTimeString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            var reg1 = /^([01][0-9]|2[0-3])([0-5][0-9])$/;
            var reg2 = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
            var reg3 = /^([0-9])([0-5][0-9])$/;
            var reg4 = /^([0-5][0-9])$/;
            var reg5 = /^([0-9]):([0-5][0-9])$/;
            if (value.match(reg1)) {
                value = value.substring(0, 2) + ':' + value.substring(2, 4);
            }
            if (value.match(reg3)) {
                value = value.substring(0, 1) + ':' + value.substring(1, 3);
            }
            if (value.match(reg4)) {
                value = '00:' + value;
            }
            if (!value.match(reg2) && !value.match(reg5)) {
                value = '';
            }
            //
            return value;
        },
        /**
         * convert date for input datepiker
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        convertDateString(values) {
            if (!isArray(values)) {
                values = values.split(',');
            }
            if (!values.length) {
                return values;
            }
            const res = values.map((value) => {
                if (value == undefined || value == '' || value == null) {
                    return '';
                }
                var reg1 = /^[0-9]{8}$/;
                var reg2 = /^[0-9]{4}[/.][0-9]{2}[/.][0-9]{2}$/;
                if (value.match(reg1)) {
                    value = value.substring(0, 4) + '/' + value.substring(4, 6) + '/' + value.substring(6);
                }
                if (!value.match(reg1) && !value.match(reg2)) {
                    value = '';
                }
                if (!this.isDate(value)) {
                    value = '';
                }
                return value;
            });

            return res;
        },
        /**
         * convert year/month for input datepicker
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        convertYearMonthString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            var reg1 = /^[0-9]{6}$/;
            var reg2 = /^[0-9]{4}[/.][0-9]{2}$/;
            if (value.match(reg1)) {
                value = value.substring(0, 4) + '/' + value.substring(4, 6);
            }
            if (!value.match(reg1) && !value.match(reg2)) {
                value = '';
            }
            // if month > 12 => clear value
            if (value.substring(5, 7) && value.substring(5, 7) > 12) {
                value = '';
            }
            return value;
        },
        /**
         * convert year/month for input datepicker
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        convertYearString(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            value = value.substring(0, 4);
            return value;
        },
        /**
         * Check date type for input datepiker
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params : value
         * @access : private
         */
        isDate(string) {
            if (string == '') {
                return true;
            }
            if (string.length == 8) {
                string = string.substring(0, 4) + '/' + string.substring(4, 6) + '/' + string.substring(6);
            }
            var reg =
                /^((19|[2-9][0-9])[0-9]{2})[/.](0[13578]|1[02])[/.]31|((19|[2-9][0-9])[0-9]{2}[/.](01|0[3-9]|1[0-2])[/.](29|30))|((19|[2-9][0-9])[0-9]{2}[/.](0[1-9]|1[0-2])[/.](0[1-9]|1[0-9]|2[0-8]))|((((19|[2-9][0-9])(04|08|[2468][048]|[13579][26]))|2000)[/.](02)[/.]29)$/;
            if (string.match(reg)) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * event keydown on input datepiker
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputKeydown(e) {
            if (!this.isTimer) {
                if (
                    !(
                        (e.keyCode > 47 && e.keyCode < 58) ||
                        (e.keyCode > 95 && e.keyCode < 106) ||
                        e.keyCode == 116 ||
                        e.keyCode == 13 ||
                        e.keyCode == 46 ||
                        e.keyCode == 37 ||
                        e.keyCode == 39 ||
                        e.keyCode == 35 ||
                        e.keyCode == 36 ||
                        e.keyCode == 8 ||
                        e.keyCode == 9 ||
                        e.ctrlKey ||
                        e.keyCode == 229 ||
                        e.keyCode == 188 ||
                        e.keyCode == 191
                    )
                ) {
                    event.preventDefault();
                    return false;
                }
            } else {
                if (
                    !(
                        (e.keyCode > 47 && e.keyCode < 58) ||
                        (e.keyCode > 95 && e.keyCode < 106) ||
                        e.keyCode == 116 ||
                        e.keyCode == 13 ||
                        e.keyCode == 46 ||
                        e.keyCode == 37 ||
                        e.keyCode == 39 ||
                        e.keyCode == 35 ||
                        e.keyCode == 36 ||
                        e.keyCode == 8 ||
                        e.keyCode == 9 ||
                        e.ctrlKey ||
                        e.keyCode == 229 ||
                        e.keyCode == 186
                    )
                ) {
                    event.preventDefault();
                    return false;
                }
            }
            return true;
        },
        onChange(e) {
            let val = this.getValue(e.target.value);
            val = [...new Set(val)];
            val = this.sortDate(val);
            this.$emit('update:modelValue', val);
            this.listDate = val;
            document.getElementById(this.newId).blur();
        },
        onBlur(e) {
            if (this.onBlurEvent) {
                this.onBlurEvent(e, this.$refs['input_' + this.newId]);
            }
        },
        onDoubleClick(e) {
            if (!e.target.value) {
                e.target.value = moment().format('YYYY/MM/DD');
                this.onChange(e);
            }
        },
        onFocus(e) {
            if (this.onFocusEvent) {
                this.onFocusEvent(e);
            }
            // if (this.isTimer) {
            //     e.target.value = e.target.value.replace(':', '');
            // }
        },
        getValue(input) {
            let val = [];
            val = this.convertDateString(input);
            return val.filter((item) => item);
        },
        /**
         * update input datepiker
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        // eslint-disable-next-line no-unused-vars
        updateInput(selectedDates, dateStr) {
            this.tempDate = dateStr;
        }
    }
};
export default AnsDatePicker;
</script>
